import React from "react";
import styles from "./process.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArrowTrendUp,
    faBolt, faChartLine,
    faGrimace,
    faGrin,
    faGrinHearts,
    faGrinTears,
    faGrinWink,
    faMobileAlt, faPalette, faSearch
} from "@fortawesome/free-solid-svg-icons";
import LazyText from "../../../common/imagescroll/LazyText";


const Process: React.FC = () => {

    const precessSteps = [
        {
            title: "Discovery & Strategy",
            num: "01",
            description: "We begin by understanding your business, goals, and audience to build a clear plan."
        },
        {
            title: "Design",
            num: "02",
            description: "We create a custom design prototype that reflects your brand and get your approval."
        },
        {
            title: "Development",
            num: "03",
            description: "We build your website with clean, scalable code and smooth functionality."
        },
        {
            title: "Lunch",
            num: "04",
            description: "We deploy your website, run final checks, and ensure everything works perfectly."
        },
        {
            title: "Optimization & Continuous Support.",
            num: "05",
            description: "After launch, we monitor performance and make improvements or adjustments as needed."
        }
    ];

    return (

        <section className={styles.sectionContainer}>
            <LazyText>
                <h2 className="sectionTitle" style={{marginTop:"60px", color:"var(--theme-color-primary)"}}>
                    Our Simple, Streamlined Process
                </h2>
            </LazyText>
            <div className={styles.timelineContainer}>
                <div className={styles.timeline}>
                    {precessSteps.map((step, index) => (
                        <div key={index} className={`${styles.stepContainer} ${styles.primary}`}>
                            <div className={styles.timelineNumber}>
                                {step.num}
                            </div>
                            <div className={styles.timelineBody}>
                                <h4 className={styles.timelineTitle}>
                                    {step.title}
                                </h4>
                                <p>
                                    {step.description}
                                </p>
                            </div>
                        </div>

                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
